
TPS.GeneratePin = {
    geocoder: null,
    memberProfile: {
        SelectDealers: true,
    },
    purchaseTimeframe: {},
    trims: {},
    years: {},
    availableVehicles: {},
    dealers: {},
    availablePins: {
        personal: 0,
        sponsored: 0,
    },
    formParentSelector: null,
    errorBlockSelector: '#error-callout',
    contactBlockSelector: '.pin-contact-details',
    personalBlockSelector: '.pin-personal-details',
    purchaseBlockSelector: '.pin-purchase-details',
    pinTableSelector: '.available-pins',
    submitOverlaySelector: '.submit-overlay',
    hasMemberDetails: false,
    hasMobilePhone: false,
    retailersWrapper: jQuery('#preferredDealer .dealer-options'),
    getDealerMsg: jQuery('#preferredDealer .get-dealer-message'),
    noDealerMsg: jQuery('#preferredDealer .no-dealer-message'),
    skipVehicleSelection: false,
    init: function (formWrapper) {

        TPS.GeneratePin.formParentSelector = formWrapper;

        if (TPS.GeneratePin.formParentSelector) {
            TPS.Forms.setupClientValidation(TPS.GeneratePin.formParentSelector); // .generate-pin-form

            //Load Webservices
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.NearestDealer');
            TPS.GeneratePin.loadPurchaseTimeframe(TPS.GeneratePin.formParentSelector);
            TPS.GeneratePin.loadProfile(TPS.GeneratePin.formParentSelector);
            TPS.GeneratePin.loadVehiclesYears(TPS.GeneratePin.formParentSelector);

            jQuery('#offCanvasLeft').on('closed.zf.offcanvas', function (e) {
                TPS.Forms.resetClientValidation();                
                TPS.Forms.clearFormFields(TPS.GeneratePin.formParentSelector);
                jQuery('#vehicleYear').trigger('change');
                jQuery('#vehicle').trigger('change');
                TPS.Forms.changeFieldState(TPS.GeneratePin.contactBlockSelector, true);
                TPS.Forms.resetMessageBlock(TPS.GeneratePin.errorBlockSelector);

                TPS.GeneratePin.populateProfile(TPS.GeneratePin.formParentSelector, true);
                TPS.GeneratePin.goToStep('1');
                TPS.GeneratePin.setProgressBar(1);
                TPS.GeneratePin.clearPinRetailers();
                TPS.GeneratePin.hasMobilePhone = false;
                TPS.GeneratePin.setAvailablePinOptions();
            });

            jQuery('#VehicleProgramOption').on('change', function (e) {
                TPS.Forms.setupClientValidation(TPS.GeneratePin.formParentSelector);
            }) 
        }

    },
    loadProfile: function (f) {

        CMSApp.AV.API.Membership.MyProfile(function (d) {

            TPS.GeneratePin.memberProfile.AvailableRelationships = d.Object.AvailableRelationships;
            TPS.GeneratePin.memberProfile.Firstname = d.Object.Firstname;
            TPS.GeneratePin.memberProfile.Lastname = d.Object.Lastname;
            TPS.GeneratePin.memberProfile.Email = d.Object.Email;
            TPS.GeneratePin.memberProfile.Phone = d.Object.Phone;
            TPS.GeneratePin.memberProfile.MobilePhone = d.Object.MobilePhone;
            TPS.GeneratePin.memberProfile.Address = d.Object.Address;
            TPS.GeneratePin.memberProfile.City = d.Object.City;
            TPS.GeneratePin.memberProfile.ZipCode = d.Object.ZipCode;
            TPS.GeneratePin.memberProfile.State = d.Object.State;
            TPS.GeneratePin.memberProfile.Country = d.Object.Country;
            TPS.GeneratePin.memberProfile.SelectDealers = d.Object.SelectDealers;
            TPS.GeneratePin.populateProfile(f, true);
            TPS.GeneratePin.populateMemberDetails(f, true);
            TPS.GeneratePin.getAvailablePins(false);

            TPS.GeneratePin.setProgressBar(1);

            TPS.GeneratePin.PinListeners();

        }, TPS.Util.displayError);
    },
    loadVehiclesYears: function (f) {
        CMSApp.AV.API.Membership.AvailableVehiclesYears(function (d) {
            TPS.GeneratePin.years = d;
            TPS.Util.populateDropdown('#vehicleYear', TPS.GeneratePin.years, true, 0);
        }, TPS.Util.displayError);
    },
    loadPurchaseTimeframe: function (f) {
        CMSApp.AV.API.Pin.PurchaseTimeframeOptions(function (d) {
            TPS.GeneratePin.purchaseTimeframe = d;
        }, TPS.Util.displayError);
    },
    populateMemberDetails: function (f, p) {

        if (!TPS.GeneratePin.hasMemberDetails && p) {

            jQuery('#firstname_label', f).text(TPS.GeneratePin.memberProfile.Firstname);
            jQuery('#lastname_label', f).text(TPS.GeneratePin.memberProfile.Lastname);
            jQuery('#phoneNumber_label', f).text(TPS.GeneratePin.memberProfile.Phone);
            var MobilePhone = TPS.GeneratePin.memberProfile.MobilePhone;
            if (typeof TPS.GeneratePin.memberProfile.MobilePhone == 'undefined' || TPS.GeneratePin.memberProfile.MobilePhone == '') {
                MobilePhone = '-';
            }
            jQuery('#phoneNumberMobile_label', f).text(MobilePhone);
            jQuery('#emailAddress_label', f).text(TPS.GeneratePin.memberProfile.Email);

            jQuery('#address_label', f).text(TPS.GeneratePin.memberProfile.Address.Address);
            jQuery('#city_label', f).text(TPS.GeneratePin.memberProfile.Address.City);
            jQuery('#zipcode_label', f).text(TPS.GeneratePin.memberProfile.Address.ZipCode);
            TPS.Util.getCountryLabel(TPS.GeneratePin.memberProfile.Address.Country, '#country_label');
            TPS.Util.getStateLabel(TPS.GeneratePin.memberProfile.Address.Country, TPS.GeneratePin.memberProfile.Address.State, '#state_label');

            

            TPS.GeneratePin.hasMemberDetails = true;
        }

    },
    populateProfile: function (f, p) {
        var _f = f;
        f = jQuery(f);


        jQuery('#address', f).val(TPS.GeneratePin.memberProfile.Address.Address);
        jQuery('#city', f).val(TPS.GeneratePin.memberProfile.Address.City);
        jQuery('#zipcode', f).val(TPS.GeneratePin.memberProfile.Address.ZipCode);
        jQuery('#state', f).val(TPS.GeneratePin.memberProfile.Address.State);
        jQuery('#country', f).val(TPS.GeneratePin.memberProfile.Address.Country);
        TPS.Util.initCountryStateDropDown(_f + ' #country', _f + ' #state', TPS.GeneratePin.memberProfile.Address.Country, TPS.GeneratePin.memberProfile.Address.State);
        TPS.Util.populateDropdown(_f + ' #timeframe', TPS.GeneratePin.purchaseTimeframe, true);

        if (p) {
            jQuery('#firstname', f).val(TPS.GeneratePin.memberProfile.Firstname);
            jQuery('#lastname', f).val(TPS.GeneratePin.memberProfile.Lastname);
            jQuery('#phoneNumber', f).val(TPS.GeneratePin.memberProfile.Phone);
            jQuery('#phoneNumberMobile', f).val(TPS.GeneratePin.memberProfile.MobilePhone);
            jQuery('#emailAddress, #confirmEmailAddress', f).val(TPS.GeneratePin.memberProfile.Email);
        }

        if (TPS.GeneratePin.memberProfile.AvailableRelationships.length < 2) {
            jQuery('#relationship').parents('.form-control-wrapper').addClass('hidden');
        } else {
            jQuery('#relationship').parents('.form-control-wrapper').removeClass('hidden');
        }
        
    },
    PinListeners: function () {
        TPS.GeneratePin.contactMethodChange();
        TPS.GeneratePin.StepChange();
        TPS.GeneratePin.submitForm();
        TPS.GeneratePin.vehicleYearChanged();
        TPS.GeneratePin.vehicleChanged();
        TPS.GeneratePin.pinTypeChanged();
        //TPS.GeneratePin.cancelPin();
        TPS.GeneratePin.resendPin();
        TPS.GeneratePin.loadMoreDealers();
    },
    StepChange: function () {

        jQuery(document).on('click', '.button.go-to-step', function (e) {
            e.preventDefault();

            var currentStep, currentStepId, currentStepIdSel, currentStepNum, pinType, targetStep, targetStepId, targetStepNum, isPrev, addressValid, originType, skipVehicleSelection, goToConfirmation;

            isPrev = jQuery(this).attr('id') == 'prevStep';
            currentStep = jQuery('.form-step.active-step')
            currentStepId = currentStep.attr('id');
            currentStepIdSel = '#' + currentStepId;
            currentStepNum = currentStep.attr('data-step');
            pinType = jQuery('#relationship').val();
            originType = jQuery('#VehicleProgramOption').val();
            skipVehicleSelection = false; // skip vehicle selection
            goToConfirmation = false;

            // Skip vehicle selection for OSD & CBV
            if (originType == 'OSD' || originType == 'CBV' || originType == 'C_V') {
                skipVehicleSelection = true;

                if (originType === 'C_V') {
                    goToConfirmation = true;
                }

            }

            addressValid = true;

            if (isPrev) {
                targetStep = jQuery(currentStepIdSel).prev();
                if (currentStepNum == '3' && pinType == 0) {
                    targetStep = targetStep.prev();
                }
                if (currentStepNum == '4' && pinType == 0 && skipVehicleSelection) {
                    targetStep = targetStep.prev().prev();
                }
                if (currentStepNum == '4' && (pinType == 1 || pinType == 2) && skipVehicleSelection) {
                    targetStep = targetStep.prev();
                }
                if (goToConfirmation) {
                    targetStep = jQuery('[data-step="1"]');
                }

            } else {
                targetStep = jQuery(currentStepIdSel).next();
                if (currentStepNum == '1' && pinType == 0) {
                    targetStep = targetStep.next();
                }
                if (currentStepNum == '1' && pinType == 0 && skipVehicleSelection) {
                    targetStep = targetStep.next();
                }
                if (currentStepNum == '2' && (pinType == 1 || pinType == 2) && skipVehicleSelection) {
                    targetStep = targetStep.next();
                }
                if (goToConfirmation) {
                    targetStep = jQuery('[data-step="5"]');
                }
            }
            
            targetStepId = targetStep.attr('id');
            targetStepNum = targetStep.attr('data-step');

            if (currentStep.find(':input').length > 0 && !isPrev) {
                var valid = true;
                var hasData = false;
                currentStep.find(':input').each(function (k, v) {
                    valid = TPS.Forms.validator.element(v) && valid;
                });
                if (TPS.GeneratePin.years.length > 0 && TPS.GeneratePin.hasMemberDetails) {
                    hasData = true;
                }

                if (valid && hasData) {
                    TPS.GeneratePin.goToStep(targetStepNum);
                }

            } else {
                if (isPrev) {
                    TPS.Forms.resetClientValidation();
                    TPS.Forms.clearFormFields(currentStepIdSel);
                    if (targetStepNum == 1 && currentStepNum == '2' && jQuery('#relationship').val() == '1') {
                        TPS.GeneratePin.populateProfile(TPS.GeneratePin.formParentSelector, false);
                    }
                }
                TPS.GeneratePin.goToStep(targetStepNum);
            }


        });
    },
    goToStep: function (targ) {
        
        var targInt = parseInt(targ);

        var originType = jQuery('#VehicleProgramOption').val();
        var currId = jQuery('.form-step.active-step').attr('id');
        var targId = jQuery('.form-step[data-step="' + targ + '"]').attr('id');

        var currStep = jQuery('#' + currId);
        var tarStep = jQuery('#' + targId);

        var fadeOutSel = '';
        var fadeInSel = '';
        var totalSteps = jQuery('.form-step').length;

        if (targInt != 1) {
            fadeOutSel += '#editProfileAction';
            fadeInSel += '#prevStep';

            if (targInt == 4 || targInt == 5 || (targInt == 3 && !TPS.GeneratePin.memberProfile.SelectDealers)) {
                fadeOutSel += ', #nextStep';
                fadeInSel += ', #submitGetPin';
            } else if (targInt == totalSteps - 1 || (targInt == 2 && !TPS.GeneratePin.memberProfile.SelectDealers)) {
                fadeInSel += ', #nextStep';
                fadeOutSel += ', #submitGetPin';
            } else {
                fadeInSel += ', #nextStep';
                fadeOutSel += ', #submitGetPin';
            }

            if ((targInt == 3 && originType == "new") || (targInt == 4 && originType != "new") || originType === "C_V") {
                if (TPS.GeneratePin.memberProfile.SelectDealers && originType !== "C_V") {

                    jQuery('#preferredContactMethod').parents('.form-control-wrapper').addClass('required');
                    jQuery('#preferredContactMethod input').each(function () {
                        jQuery(this).rules('add', 'required');
                    });

                    TPS.GeneratePin.GetRetailers();

                } else {
                    jQuery('#preferredContactMethod').parents('.form-control-wrapper').removeClass('required');
                    jQuery('#preferredContactMethod input').each(function () {
                        jQuery(this).rules('remove', 'required');
                    });
                }
            }

        } else {
            fadeInSel += '#editProfileAction, #nextStep';
            fadeOutSel += '#submitGetPin, #prevStep';
        }
        
        currStep.removeClass('active-step');
        tarStep.addClass('active-step');

        jQuery('.off-canvas').animate({
            scrollTop: 0
        });
        jQuery(fadeOutSel).fadeOut(250, function () {
            jQuery(fadeInSel).fadeIn(250).css("display", "inline-block");
        });

        TPS.GeneratePin.setProgressBar(targInt);

    },
    setProgressBar: function (step) {

        var f = TPS.GeneratePin.formParentSelector;

        var progDivider = 3;
        var stepNum = step;
        var stepNumLabel = stepNum;
        var selectRetailer = TPS.GeneratePin.memberProfile.SelectDealers;
        var relationshipsLength = TPS.GeneratePin.memberProfile.AvailableRelationships.length;
        var relationship = jQuery('#relationship').val();

        if (relationshipsLength > 1 && selectRetailer) {
            progDivider = 4;
        }
        
        if (step > 1) {
            if (relationship == '0') {
                stepNum = step - 1;
                if (selectRetailer) {
                    progDivider = 3;
                } else {
                    progDivider = 2;
                }
            } else {
                if (selectRetailer) {
                    progDivider = 4;
                } else {
                    progDivider = 3;
                }
            }
           
        } 
        var label = "";
        
        switch (step) {
            case 1:
                if (TPS.GeneratePin.memberProfile.AvailableRelationships.length > 1) {
                    label += window.Labels.Progress.stepLabels.PinType;
                    label += " / ";
                }
                label += window.Labels.Progress.stepLabels.MemberDetails;

                break;
            case 2:
                label += window.Labels.Progress.stepLabels.RecipientInfo;
                break;
            case 3:
                label += window.Labels.Progress.stepLabels.VehiclePreference;
                break;
            case 4:
                label += window.Labels.Progress.stepLabels.SelectRetailer;
                break;
            case 5:
                label += window.Labels.Progress.stepLabels.Confirm;
                break;
            default:
                label += window.Labels.Progress.stepLabels.MemberDetails;
        }

        jQuery(f).find(".progress-wrapper .progress-label").html(label);

        jQuery(f).find(".progress-wrapper .progress .progress-meter").animate({ width: ((100 / progDivider) * stepNum) + "%" }, 250, "linear");

    },
    submitForm: function () {

        jQuery(TPS.GeneratePin.formParentSelector).find('.submit-form').on('click', function (e) {
            e.preventDefault();

            TPS.Forms.resetMessageBlock(TPS.GeneratePin.errorBlockSelector);

            if (TPS.Forms.validator.checkForm()) {

                jQuery(TPS.PromotionPage.submitOverlaySelector).fadeIn();

                var vals = TPS.Forms.getFormVals(TPS.GeneratePin.formParentSelector);

                var mobilePhone = vals.phoneNumberMobile;
                var preferredDealer = 0;

                var contactMethod = '';

                if (TPS.GeneratePin.memberProfile.SelectDealers && vals.VehicleProgramOption !== 'C_V') {
                    preferredDealer = jQuery("#preferredDealer input[type='radio']:checked").val();
                    contactMethod = jQuery("#preferredContactMethod input[type='radio']:checked").val();
                    if (contactMethod == 'doNotContactMe') {
                        preferredDealer = 0;
                    }
                } 
                
                if (mobilePhone == '' && vals.phoneNumberMobile_sms && vals.phoneNumberMobile_sms != '') {
                    mobilePhone = vals.phoneNumberMobile_sms;
                    TPS.GeneratePin.memberProfile.MobilePhone = mobilePhone;
                }

                if (vals.relationship > 0) {

                    CMSApp.AV.API.Pin.CreateSponsoredPin(
                        vals.relationship,
                        vals.firstname,
                        vals.lastname,
                        vals.address,
                        vals.city,
                        vals.zipcode,
                        vals.state,
                        vals.country,
                        vals.emailAddress,
                        vals.phoneNumber,
                        mobilePhone,
                        vals.vehicle,
                        vals.timeframe,
                        vals.trim,
                        preferredDealer,
                        contactMethod,
                        vals.vehicleYear,
                        vals.VehicleProgramOption,
                        success,
                        fail
                    );

                } else {
                    
                    CMSApp.AV.API.Pin.CreatePersonalPin(
                        vals.vehicle,
                        vals.timeframe,
                        vals.trim,
                        preferredDealer,
                        contactMethod,
                        mobilePhone,
                        vals.vehicleYear,
                        vals.VehicleProgramOption,
                        success,
                        fail
                    );
                }

            } else {

                console.log(TPS.Forms.validator.numberOfInvalids() + ' validation errors');
            }

            var successData;

            function success(data) {
                successData = data;
                if (successData.Success) {

                    jQuery('#offCanvasLeft').on('closed.zf.offcanvas', closePanel);
                    $('#offCanvasLeft').foundation('close');
                    jQuery('#offCanvasLeft').off('closed.zf.offcanvas', closePanel);

                } else {
                    TPS.Forms.scrollToMessages(successData.ErrorMessages, true, TPS.GeneratePin.errorBlockSelector, '.hidden-magellan-error', false);
                }
                jQuery(TPS.PromotionPage.submitOverlaySelector).fadeOut();
            }

            function fail(data) {
                TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, false, TPS.GeneratePin.errorBlockSelector, '.hidden-magellan-error', true);
                jQuery(TPS.PromotionPage.submitOverlaySelector).fadeOut();
            }

            function closePanel() {

                var pinTable = jQuery(TPS.GeneratePin.pinTableSelector);

                pinTable.find('.no-pins-row').remove();
                pinTable.find('.header').removeClass('hidden').after(TPS.GeneratePin.addPinRow(successData.Object));

                TPS.GeneratePin.getAvailablePins(true);

                jQuery('#pin-success-message').fadeIn(250).delay(5000).fadeOut();

                //document.location = successData.RedirectURL;
            }

        });
    },
    addPinRow: function (data) {

        var pinRow = jQuery('<tr>').addClass('pin-row');

        var createDay_prim = data.Created.getDate();
        var createDay = createDay_prim < 10 ? "0" + createDay_prim.toString() : createDay_prim;
        var createMonth_prim = data.Created.getMonth() + 1;
        var createMonth = createMonth_prim < 10 ? "0" + createMonth_prim.toString() : createMonth_prim;
        var pinCreated = jQuery('<td>').addClass('pin-date').text(data.Created.getFullYear() + '-' + createMonth + '-' + createDay);

        var pinNumber = jQuery('<td>').addClass('pin-number').text(data.PIN);
        var pinType = jQuery('<td>').addClass('pin-type').text(data.PIN.substr(0, 1));
        var pinStatus = jQuery('<td>').addClass('pin-status').html('<span class="pin-tatus-text">' + data.Status + '</span>');
        var pinActions = jQuery('<td>').addClass('pin-actions').html(TPS.GeneratePin.addPinActions(data.ID));

        pinRow.append(pinCreated, pinNumber, pinType, pinStatus, pinActions);
        return pinRow;

    },
    addPinActions: function (gid) {

        var html = ' <button type="button" href="#" title="' + window.Labels.DownloadPin + '" class="action-pin-download" data-pin-guid="' + gid + '">';
        html += '   <span class="sr-only">' + window.Labels.DownloadPin + '</span >';
        html += '   <span class="icon fa fa-envelope-o"></span>';
        html += '</button>&nbsp;&nbsp;';

        return html;
    },
    cancelPin: function () {
        console.log('PIN cancelation is no longer supported!');
    },
    resendPin: function () {

        jQuery(document).on('click', '.action-pin-download', function (e) {
            e.preventDefault();
            var pinGuid = jQuery(this).attr('data-pin-guid');
            jQuery(this).attr('disabled', true);
            jQuery(TPS.PromotionPage.submitOverlaySelector).fadeIn();
            CMSApp.AV.API.Pin.Resend(pinGuid, success, fail, pinGuid);
        });

        function success(data, context) {
            if (data.Success) {
                jQuery('#resend-pin-success-message').fadeIn(250).delay(5000).fadeOut();
                if (data.RedirectURL) {
                    document.location = data.RedirectURL;
                }
            } else {
                console.log(data);
            }
            jQuery(TPS.PromotionPage.submitOverlaySelector).fadeOut();
        }

        function fail(data, context) {
            console.log('fail');
            console.log(data);
            var pinGuid = context;
            jQuery('[data-pin-guid=' + pinGuid + ']').removeAttr('disabled');
            jQuery(TPS.PromotionPage.submitOverlaySelector).fadeOut();
        }

    },
    vehicleYearChanged: function () {
        jQuery('#vehicleYear').on('change', function (e) {
            var selection = jQuery(this).val();
            if (selection != "" && typeof selection != 'undefined') {
                jQuery('#vehicle-control-wrapper').addClass('populating');
                jQuery('#vehicle').prop("disabled", true);
                jQuery('#trim').prop("disabled", true);

                TPS.GeneratePin.loadVehicle(selection);
            } else {
                jQuery('#vehicle-control-wrapper').removeClass('populating');
                jQuery('#vehicle').val('');
                jQuery('#vehicle').text('');
                jQuery('#vehicle').prop("disabled", true);
                jQuery('#trims-control-wrapper').removeClass('populating');
                jQuery('#trim').val('');
                jQuery('#trim').text('');
                jQuery('#trim').prop("disabled", true);
            }
        });

    },
    loadVehicle: function (year) {
        CMSApp.AV.API.Membership.AvailableVehicles(year, function (d) {
            TPS.GeneratePin.availableVehicles = d;
            TPS.Util.populateDropdown('#vehicle', TPS.GeneratePin.availableVehicles, true);

            jQuery('#vehicle-control-wrapper').addClass('populating');
            jQuery('#vehicle').prop("disabled", false);

        }, function () {
            jQuery('#vehicle-control-wrapper').removeClass('populating');
            jQuery('#vehicle').prop("disabled", true);
            TPS.Util.displayError();
        });
    },
    vehicleChanged: function () {

        jQuery('#vehicle').on('change', function (e) {
            var vehicleSelected = jQuery(this).val();
            var yearSelected = jQuery('#vehicleYear').val();
            if (vehicleSelected != "" && typeof vehicleSelected != 'undefined') {
                jQuery('#trims-control-wrapper').addClass('populating');
                jQuery('#trim, #vehicle').prop("disabled", true);
                TPS.GeneratePin.loadTrims(vehicleSelected, yearSelected);
            } else {
                jQuery('#trims-control-wrapper').removeClass('populating');
                jQuery('#trim').val('');
                jQuery('#trim').text('');
                jQuery('#trim').prop("disabled", true);
            }
        });

    },
    loadTrims: function (vehicle, year) {
        jQuery('#trim').prop("disabled", true);
        CMSApp.AV.API.Membership.Trims(vehicle, year, function (d) {
            TPS.GeneratePin.trims = d;

            TPS.Util.populateDropdown('#trim', TPS.GeneratePin.trims, true);

            if (vehicle == 'Unknown') {
                jQuery('#trim').val('Unknown');
            }

            jQuery('#trims-control-wrapper').removeClass('populating');
            jQuery('#trim, #vehicle').prop("disabled", false);

        }, function () {
            jQuery('#trims-control-wrapper').removeClass('populating');
            jQuery('#trim, #vehicle').prop("disabled", false);
            TPS.Util.displayError();
        });
    },
    pinTypeChanged: function () {

        jQuery(document).on('change', '#relationship', function (e) {

            TPS.Forms.resetClientValidation();
            var selectedVal = jQuery(this).val();
            var vehicleProgramOption = jQuery('#VehicleProgramOption');
                
            if (selectedVal > 0) {

                TPS.Forms.changeFieldState(TPS.GeneratePin.contactBlockSelector, false);
                TPS.Forms.changeFieldState(TPS.GeneratePin.purchaseBlockSelector, false);

                if (selectedVal > 1) {
                    TPS.Forms.clearFormFields(TPS.GeneratePin.contactBlockSelector);
                } else {
                    TPS.Forms.clearFormFields(TPS.GeneratePin.personalBlockSelector);
                    TPS.GeneratePin.populateProfile(TPS.GeneratePin.formParentSelector, false);
                }
                jQuery('#phoneNumberMobile, #phoneNumber, #terms_optin_sponsored').parents('.form-control-wrapper').addClass('required');
                TPS.Forms.clearFormFields(TPS.GeneratePin.purchaseBlockSelector);
                jQuery('#country').val(jQuery('#country option:first').val());

                //vehicleProgramOption.find('[value="C_V"]').prop('disabled', true);
                vehicleProgramOption.val('');

            } else {

                jQuery('#phoneNumberMobile, #phoneNumber, #terms_optin_sponsored').parents('.form-control-wrapper').removeClass('required');
                TPS.Forms.changeFieldState(TPS.GeneratePin.contactBlockSelector, true);
                TPS.GeneratePin.populateProfile(TPS.GeneratePin.formParentSelector, true);

                //vehicleProgramOption.find('[value="C_V"]').prop('disabled', false);
                vehicleProgramOption.val('');
            }
        });

    },
    getAvailablePins: function (update) {

        CMSApp.AV.API.Membership.MyPinsAvailable(function (d) {
            if (d.Success) {
                TPS.GeneratePin.availablePins.sponsored = d.Object.SponsoredPins;
                TPS.GeneratePin.availablePins.personal = d.Object.PersonalPins;
                if (update) {
                    TPS.GeneratePin.updateAvailablePins();
                }

                TPS.GeneratePin.setAvailablePinOptions();
            }
        }, TPS.Util.displayError);

    },
    setAvailablePinOptions: function () {

        // if the relationship dropdown is empty, populate it
        if ($('#relationship option').length === 0) {
            TPS.Util.populateDropdown('#relationship', TPS.GeneratePin.memberProfile.AvailableRelationships, true, 0);
        }

        // if the the member has more than one pin relationship option
        if (TPS.GeneratePin.memberProfile.AvailableRelationships.length > 1) {

            // if the member has 0 sponsored PINs available,
            // disable those options
            if (TPS.GeneratePin.availablePins.sponsored == 0) {
                                
                jQuery('#relationship option[value="1"], #relationship option[value="2"]').prop('disabled', true);

            } else {
                jQuery('#relationship option[value="1"], #relationship option[value="2"]').prop('disabled', false);
            }

            // if the member has 0 personal PINs available,
            // disable that option
            if (TPS.GeneratePin.availablePins.personal == 0) {
                jQuery('#relationship option[value="0"]').prop('disabled', true);
                jQuery('#relationship').val('1').trigger('change');
            } else {
                jQuery('#relationship option[value="0"]').prop('disabled', false);
                jQuery('#relationship').val('0').trigger('change');
            }

        }
    },
    updateAvailablePins: function (d) {

        var personalPins = TPS.GeneratePin.availablePins.personal;
        var sponsoredPins = TPS.GeneratePin.availablePins.sponsored;

        jQuery('.personal-pins').find('.pins-val').text(personalPins);
        jQuery('.sponsored-pins').find('.pins-val').text(sponsoredPins);

        if (sponsoredPins > 0 || personalPins > 0) {
            jQuery('.no-pins-message').fadeOut();
            jQuery('a[data-get-pin]').attr('data-toggle', 'offCanvasLeft').removeAttr('disabled');
            Foundation.reInit(jQuery('offCanvas'));
        } else if (sponsoredPins === 0 && personalPins === 0) {
            jQuery('.no-pins-message').fadeIn();
            jQuery('a[data-get-pin]').attr('disabled', true).removeAttr('data-toggle');
        }

    },
    GetRetailers: function () {
        var pinType = jQuery('#relationship').val();

        if (pinType == '0') {

            CMSApp.AV.API.NearestDealer.GetNearestDealersByCustomer(function (d) {
                TPS.GeneratePin.dealers = d;
                TPS.GeneratePin.populatePinRetailers();
            }, TPS.Util.displayError)

        } else {

            CMSApp.AV.API.NearestDealer.GetNearestDealersByPinAddress(
                jQuery('#address').val(),
                jQuery('#city').val(),
                jQuery('#zipcode').val(),
                jQuery('#country').val(),
                'APLAN',
                function (d) {
                    TPS.GeneratePin.dealers = d;
                    TPS.GeneratePin.populatePinRetailers();
                }, TPS.Util.displayError);

        }
    },
    populatePinRetailers: function () {
        
        TPS.GeneratePin.clearPinRetailers();

        if (TPS.GeneratePin.dealers.length > 0) {
            jQuery.each(TPS.GeneratePin.dealers, function (i, v) {
                TPS.GeneratePin.getDealerMsg.fadeOut();
                TPS.GeneratePin.retailersWrapper.append(TPS.GeneratePin.buildRetailerOptions(i, v));

                // If it's the 4th item, so add the "Load 3+ more retailers" button
                if (i == 3) {
                    TPS.GeneratePin.retailersWrapper.after(TPS.GeneratePin.buildRetailerLoadMoreButton());
                }
            });
        } else {
            TPS.GeneratePin.getDealerMsg.fadeOut();
            TPS.GeneratePin.noDealerMsg.fadeIn();
        }
        if (jQuery('#relationship').val() == '0' && TPS.GeneratePin.memberProfile.Address.PreferredDealerID) {
            TPS.GeneratePin.checkPreferredDealer();
        }
    },
    clearPinRetailers: function () {
        
        TPS.GeneratePin.retailersWrapper.empty();
        TPS.GeneratePin.getDealerMsg.fadeIn();
        TPS.GeneratePin.noDealerMsg.fadeOut();

    },
    buildRetailerOptions: function (i, v) {

        var html = '<input type="radio" class="dealer-input ' + (i > 2 ? 'dealer-input-hidden' : '') + '" name="preferredDealer" id="preferredDealer_' + i + '" value="' + v.CompanyID + '"/>';
        html += '<label for="preferredDealer_' + i + '" class="dealer-label ' + (i > 2 ? 'dealer-label-hidden' : '') + '">';
        html += '<span class="dealer-name">' + v.Name + '</span>';
        html += '<span class="dealer-address">' + v.Address + ',&nbsp;' + v.City + '&nbsp;&nbsp;' + v.Zipcode + '</span>';
        html += '<span class="dealer-distance">' + TPS.GeneratePin.convertRetailerDist(v.Distance) + '</span>'
        html += '</label>'

        return html;
    },
    buildRetailerLoadMoreButton: function () {

        var html = '<a class="dealer-load-more" href="#">' + window.Labels.LoadMoreDealers + '</a>';
        return html;

    },
    loadMoreDealers: function () {

        // Display the hidden dealers
        jQuery(document).on('click', '.dealer-load-more', function (e) {
            e.preventDefault();
            // Display the hidden dealers
            TPS.GeneratePin.retailersWrapper.find('.dealer-input.dealer-input-hidden, .dealer-label.dealer-label-hidden').slideDown().css('display', 'inline-block');
            // Hide the "load more" button
            $(this).slideUp();
        });

    },
    checkPreferredDealer: function (d) {

        jQuery(".dealer-input[value='" + TPS.GeneratePin.memberProfile.Address.PreferredDealerID + "']").prop('checked', true);

        // If the selected item is the 4th, 5th or 6th, so show all the 6 available retailers
        if (jQuery(".dealer-input[value='" + TPS.GeneratePin.memberProfile.Address.PreferredDealerID + "']").next('label').index() > 5) {
            jQuery('.dealer-load-more').click();
        }

    },
    convertRetailerDist: function (d, u) {

        var dist = d * 0.00062137;

        if (typeof u === 'undefined') {
            u = window.Labels.DealerDistanceUnit;
        }

        var label = Math.round(dist) + '&nbsp;' + u;

        return label;
    },
    CheckMobilePhone: function () {
        TPS.GeneratePin.hasMobilePhone;
        var mobileVal = jQuery('#phoneNumberMobile').val();
        jQuery('.sms-option .sms-number').remove();

        var html = '';
        if (mobileVal != '') {
            TPS.GeneratePin.hasMobilePhone = true;
            html += '<span class="sms-number has-sms-number">(' + window.Labels.SendSmsMsg + '&nbsp;' + mobileVal + ')</span>';

        } else {
            html += '<span class="sms-number"><input type="text" id="phoneNumberMobile_sms" name="phoneNumberMobile_sms" placeholder="' + window.Labels.SendSmsNumber + '" /></span>';
        }

        jQuery('.sms-option').append(html);

        if (!TPS.GeneratePin.hasMobilePhone) {

            TPS.Forms.useValidatorMethods['av_phone']('phoneNumberMobile_sms', window.validationMessages.pattern.phoneNumberMobile.message);
        }
    },
    contactMethodChange: function () {
        jQuery(document).on('change', '#preferredContactMethod input[type="radio"]', function (e) {
            var selectedVal = jQuery(this).val();
            
            if (selectedVal == 'doNotContactMe') {
                
                jQuery('.preferred-dealer-section').fadeOut(250);
                TPS.Forms.resetClientValidation();
                jQuery(TPS.GeneratePin.retailersWrapper).find(':input').each(function () {
                    jQuery(this).rules('remove', 'required');
                });

                if (!TPS.GeneratePin.hasMobilePhone) {
                    jQuery('#phoneNumberMobile_sms').rules('remove', 'required');
                    jQuery('#phoneNumberMobile_sms').val('');
                    jQuery('.sms-number').removeClass('add-sms-number');
                    jQuery('span[id^="phoneNumberMobile_sms"]').hide();
                }

            } else {

                jQuery('.preferred-dealer-section').fadeIn(250);
                jQuery(TPS.GeneratePin.retailersWrapper).find(':input').each(function () {
                    jQuery(this).rules('add', { required: true });
                });

                if (!TPS.GeneratePin.hasMobilePhone) {
                    if (selectedVal == 'sms') {
                        jQuery('#phoneNumberMobile_sms').val('');
                        jQuery('#phoneNumberMobile_sms').rules('add', {
                            required: true,
                            messages: {
                                required: window.validationMessages.required.phoneNumberMobile
                            }

                        });
                        jQuery('.sms-number').addClass('add-sms-number');
                    } else {
                        jQuery('#phoneNumberMobile_sms').rules('remove', 'required');
                        jQuery('#phoneNumberMobile_sms').val('');
                        jQuery('.sms-number').removeClass('add-sms-number');
                        jQuery('span[id^="phoneNumberMobile_sms"]').hide();
                    }
                }

            }           
        });
    },
    checkAddress: function(nextStep) {

        if (!TPS.GeneratePin.geocoder) {            
            TPS.GeneratePin.geocoder = new google.maps.Geocoder()            
        }                   
        
        var f, address, street, city, zip, stateId, state, countryId, country, zipcode;
        f = jQuery(TPS.GeneratePin.formParentSelector);
        street = jQuery('#address', f).val();
        city = jQuery('#city', f).val();
        zipcode = jQuery('#zipcode', f).val();
        country = jQuery('#country option:selected', f).text();
        state = jQuery('#state option:selected', f).text();

        address = street + ", " + city + ", " + state + ", " + zipcode + ", " + country;
        
        TPS.GeneratePin.geocoder.geocode({ 'address': address },
            function (results, status) {
                if (status == 'OK') {
                    return true;
                } else {
                    return false;
                }

            }
        );
        

        
        
    }
}
